export default {
  getPosition(state) {
    return state.position
  }
}
